<template>
    <div :class='style'>
        <RuleWrapper
            :placeholder="placeholder"
            :store="store"
            :removable='false' 
            v-if='modelValue' 
            :value="modelValue" 
            @input="saveUpdate"
        ></RuleWrapper>
    </div>
</template>

<style scoped>
.box {
    border-radius:    4px;
    padding:          1.5rem;
    background-color: #f8f8f8;
    height:           450px;
    overflow:         scroll;
}
</style>

<script>
import RuleWrapper from './RuleWrapper.vue';

export default {
    name: 'RuleBuilder', 
    components: { RuleWrapper },
    props: {
        modelValue:  Object,
        store:       Object,
        placeholder: String,
        custom_class: {
            type: Object,
            default: null
        }
    },
    computed: {
        style() {
            return this.custom_class || { box: true }
        }
    },
    methods: {
    saveUpdate(e) {
        //console.log(e)
        this.$emit('update:modelValue', e)
    }
    },
    created() {
        if (!this.modelValue) {
            const rule = {
                op: 'and',
                rules: [
                    {
                        op: "==",
                        field: null,
                        value: "",
                    }
                ]
            };
            this.$emit("update:modelValue", rule);
        }
    },
}
</script>
